import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
export default new Router({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Login',
    component: r => require.ensure([], () => r(require('../components/login')), 'Login')
  },
  {
    path: '/register',
    name: "Register",
    component: r => require.ensure([], () => r(require('../components/register')), 'Register')
  },
  {
    path: '/supplementSku',
    name: "supplementSku",
    component: r => require.ensure([], () => r(require('../components/supplementSku')), 'supplementSku')
  },
  // {
  //     path: '/registerAccount',
  //     name: 'registerAccount',
  //     component: r => require.ensure([], () => r(require('../components/register/registerAccount')), 'registerAccount')
  // },
  {
    path: '/company',
    name: "Company",
    component: r => require.ensure([], () => r(require('../components/company')), 'Company')
  },
  {
    path: '/adurlImg',
    name: "adurlImg",
    component: r => require.ensure([], () => r(require('../components/antstore/adurlImg.vue')), 'Company')
  },
  {
    path: '/changePassword',
    name: 'ChangePassword',
    component: r => require.ensure([], () => r(require('../components/changePassword')), 'ChangePassword')
  },
  {
    path: '/changePasswords',
    name: 'ChangePasswords',
    component: r => require.ensure([], () => r(require('../components/changePasswords')), 'ChangePasswords')
  },
  {
    path: '/deadLink',
    name: "DeadLink",
    component: r => require.ensure([], () => r(require('../components/deadLink')), 'DeadLink')
  },
  {
    path: '/resetPassword',
    name: "ResetPassword",
    component: r => require.ensure([], () => r(require('../components/resetPassword')), 'ResetPassword')
  },
  {
    path: '/antStore',
    name: 'antStore',
    component: r => require.ensure([], () => r(require('../components/antstore/antStore.vue')), 'antStore')
  },
  {
    path: '/antStoreDetail',
    name: 'antStoreDetail',
    component: r => require.ensure([], () => r(require('../components/antstore/antStoreDetail.vue')), 'antStoreDetail')
  },
  {
    path: '/fromAD',
    name: 'fromAD',
    component: r => require.ensure([], () => r(require('../components/fromAD.vue')), 'fromAD')
  },
  {
    path: '/fromAlibaba',
    name: 'fromAlibaba',
    component: r => require.ensure([], () => r(require('../components/fromAlibaba.vue')), 'fromAlibaba')
  },
  {
    path: '/keyWords',
    name: 'keyWords',
    component: r => require.ensure([], () => r(require('../components/helpCenter/keyWords.vue')), 'keyWords')
  },
  {
    path: '/pluginInstructions',
    name: 'pluginInstructions',
    component: r => require.ensure([], () => r(require('../components/product/pluginInstructions.vue')), 'pluginInstructions')
  },
  {
    path: '/help',
    name: 'help',
    component: r => require.ensure([], () => r(require('../components/officialWebsite/help.vue')), 'help')
  },
  {
    path: '/features',
    name: 'features',
    component: r => require.ensure([], () => r(require('../components/officialWebsite/features.vue')), 'features')
  },
  {
    path: '/pricing',
    name: 'pricing',
    component: r => require.ensure([], () => r(require('../components/officialWebsite/pricing.vue')), 'pricing')
  },
  {
    path: '/index',
    name: 'index',
    component: r => require.ensure([], () => r(require('../components/officialWebsite/index.vue')), 'index')
  },
  {
    path: '/home',
    name: 'Home',
    component: r => require.ensure([], () => r(require('../components/home')), 'Home'),
    children: [{
      path: '/home/orderAE',
      name: 'Order',
      component: r => require.ensure([], () => r(require('../components/orderAE')), 'Order')
    },
    {
      path: '/home/orderList',
      name: 'OrderList',
      meta: {
        oneTitle: '订单管理',
        twoTitle: '订单跟踪'
      },
      component: r => require.ensure([], () => r(require('../components/orderList')), 'OrderList')
    },
    {
      path: '/home/order',
      name: 'Order1688',
      meta: {
        oneTitle: '订单管理',
        twoTitle: '下单管理'
      },
      component: r => require.ensure([], () => r(require('../components/order1688')), 'Order1688')
    },
    {
      path: '/home/order1688',
      name: 'Order1688',
      component: r => require.ensure([], () => r(require('../components/order1688')), 'Order1688')
    },
    {
      path: '/home/pleaseOrder',
      name: 'PleaseOrder',
      component: r => require.ensure([], () => r(require('../components/pleaseOrder')), 'PleaseOrder')
    },
    {
      path: '/home/orderPlaced',
      name: 'OrderPlaced',
      component: r => require.ensure([], () => r(require('../components/orderPlaced')), 'OrderPlaced')
    },
    {
      path: '/home/productQuery',
      name: 'ProductQuery',
      meta: {
        oneTitle: '寻源管理',
        twoTitle: 'SKUID查询'
      },
      component: r => require.ensure([], () => r(require('../components/productQuery')), 'ProductQuery')
    },
    {
      path: '/home/productQueryCopy',
      name: 'ProductQueryCopy',
      meta: {
        oneTitle: '寻源管理',
        twoTitle: '组合SKUID查询'
      },
      component: r => require.ensure([], () => r(require('../components/productQueryCopy')), 'ProductQueryCopy')
    },
    {
      path: '/home/productList',
      name: 'ProductList',
      component: r => require.ensure([], () => r(require('../components/productList')), 'ProductList')
    },
    {
      path: '/home/myProduct',
      name: 'myProduct',
      component: r => require.ensure([], () => r(require('../components/myProduct')), 'myProduct')
    },
    {
      path: '/home/address',
      name: 'address',
      component: r => require.ensure([], () => r(require('../components/address')), 'address')
    },
    {
      path: '/home/userInfo',
      name: 'userInfo',
      component: r => require.ensure([], () => r(require('../components/userInfo')), 'userInfo')
    },
    {
      path: '/home/user',
      name: 'user',
      component: r => require.ensure([], () => r(require('../components/user')), 'user')
    },
    {
      path: '/home/work',
      name: 'work',
      component: r => require.ensure([], () => r(require('../components/work')), 'work')
    },
    {
      path: '/home/sourcingWork',
      name: 'sourcingWork',
      meta: {
        oneTitle: '工单管理',
        twoTitle: '寻源工单'
      },
      component: r => require.ensure([], () => r(require('../components/sourcingWork')), 'sourcingWork')
    },
    {
      path: '/home/purchase',
      name: 'purchase',
      component: r => require.ensure([], () => r(require('../components/purchase')), 'purchase')
    },
    {
      path: '/home/import',
      name: 'importList',
      meta: {
        oneTitle: '商品管理',
        twoTitle: '草稿商品'
      },
      component: r => require.ensure([], () => r(require('../components/product/importList')), 'importList')
    },
    {
      path: '/home/myProducts',
      name: 'myProducts',
      component: r => require.ensure([], () => r(require('../components/product/myProducts')), 'myProducts')
    },
    {
      path: '/home/push',
      name: 'saleProduct',
      meta: {
        oneTitle: '商品管理',
        twoTitle: '店铺商品'
      },
      component: r => require.ensure([], () => r(require('../components/product/saleProduct')), 'saleProduct')
    },
    {
      path: '/home/settingProduct',
      name: 'settingProduct',
      component: r => require.ensure([], () => r(require('../components/product/settingProduct')), 'settingProduct')
    },
    {
      path: '/home/bazaar',
      name: 'searchProducts',
      meta: {
        oneTitle: '商品管理',
        twoTitle: '商品市场'
      },
      component: r => require.ensure([], () => r(require('../components/product/searchProducts')), 'searchProducts')
    },
    {
      path: '/home/bigDataProducts',
      name: 'bigDataProducts',
      meta: {
        oneTitle: '商品管理',
        twoTitle: '大数据选品'
      },
      component: r => require.ensure([], () => r(require('../components/product/bigDataProducts')), 'bigDataProducts')
    },
    {
      path: '/home/capitalAccount',
      name: 'capitalAccount',
      meta: {
        oneTitle: '资金管理',
        twoTitle: '资金账号'
      },
      component: r => require.ensure([], () => r(require('../components/capitalAccount')), 'capitalAccount')
    },
    {
      path: '/home/records',
      name: 'records',
      meta: {
        oneTitle: '资金管理',
        twoTitle: '交易记录'
      },
      component: r => require.ensure([], () => r(require('../components/records')), 'records')
    },
    {
      path: '/home/capitalWork',
      name: 'capitalWork',
      component: r => require.ensure([], () => r(require('../components/capitalWork')), 'capitalWork')
    },
    {
      path: '/home/closeWork',
      name: 'closeWork',
      component: r => require.ensure([], () => r(require('../components/closeWork')), 'closeWork')
    },
    {
      path: '/home/refundTop',
      name: 'refundTop',
      component: r => require.ensure([], () => r(require('../components/refundTop')), 'refundTop')
    },
    {
      path: '/home/refund',
      name: 'refund',
      component: r => require.ensure([], () => r(require('../components/refund')), 'refund')
    },
    {
      path: '/home/refundInformation',
      name: 'refundInformation',
      component: r => require.ensure([], () => r(require('../components/refundInformation')), 'refundInformation')
    },
    {
      path: '/home/sourceInformation',
      name: 'sourceInformation',
      meta: {
        oneTitle: '寻源管理',
        twoTitle: '寻源订单'
      },
      component: r => require.ensure([], () => r(require('../components/source/sourceInformation')), 'sourceInformation')
    },
    {
      path: '/home/skuSource',
      name: 'skuSource',
      component: r => require.ensure([], () => r(require('../components/source/skuSource')), 'skuSource')
    },
    {
      path: '/home/matching',
      name: 'matching',
      meta: {
        oneTitle: '寻源管理',
        twoTitle: '单品套餐'
      },
      component: r => require.ensure([], () => r(require('../components/source/matching')), 'matching')
    },
    {
      path: '/home/findSource',
      name: 'findSource',
      meta: {
        oneTitle: '寻源管理',
        twoTitle: '等待寻源'
      },
      component: r => require.ensure([], () => r(require('../components/source/findSource')), 'findSource')
    },
    {
      path: '/home/exportMenu',
      name: 'exportMenu',
      meta: {
        oneTitle: '导出管理',
        twoTitle: '导出菜单'
      },
      component: r => require.ensure([], () => r(require('../components/exportMenu')), 'exportMenu')
    },
    {
      path: '/home/inventory',
      name: 'inventory',
      meta: {
        oneTitle: '寻源管理',
        twoTitle: '库存表'
      },
      component: r => require.ensure([], () => r(require('../components/source/inventory')), 'inventory')
    },
    {
      path: '/home/setting',
      name: 'setting',
      meta: {
        twoTitle: '系统设置'
      },
      component: r => require.ensure([], () => r(require('../components/setting/settingIndex')), 'setting')
    },
    {
      path: '/home/orderGet',
      name: 'orderGet',
      meta: {
        oneTitle: '订单管理',
        twoTitle: '获取订单'
      },
      component: r => require.ensure([], () => r(require('../components/orderGet')), 'orderGet')
    },
      {
        path: '/home/orderGetNew',
        name: 'orderGetNew',
        meta: {
          oneTitle: '订单管理',
          twoTitle: '新版获取订单'
        },
        component: r => require.ensure([], () => r(require('../components/orderGetNew')), 'orderGetNew')
      },
      {
        path: '/home/currentMapping',
        name: 'currentMapping',
        meta: {
          oneTitle: '订单管理',
          twoTitle: '映射情况'
        },
        component: r => require.ensure([], () => r(require('../components/currentMapping')), 'currentMapping')
      },
      {
        path: '/home/orderGetTest',
        name: 'orderGetTest',
        meta: {
          oneTitle: '订单管理',
          twoTitle: '测试版获取订单'
        },
        component: r => require.ensure([], () => r(require('../components/orderGetTest')), 'orderGetTest')
      },
      {
        path: '/home/orderFulfillmentAuto',
        name: 'orderFulfillmentAuto',
        meta: {
          oneTitle: '订单管理',
          twoTitle: '履约自动化'
        },
        component: r => require.ensure([], () => r(require('../components/orderFulfillmentAuto')), 'orderFulfillmentAuto')
      },
      {
        path: '/home/checkorderbyem',
        name: 'checkorderbyem',
        meta: {
          oneTitle: '订单管理',
          twoTitle: '邮箱查订单'
        },
        component: r => require.ensure([], () => r(require('../components/checkorderbyem')), 'checkorderbyem')
      },
      {
        path: '/home/timeTracking',
        name: 'timeTracking',
        meta: {
          oneTitle: '订单管理',
          twoTitle: '物流时效跟踪'
        },
        component: r => require.ensure([], () => r(require('../components/timeTracking')), 'timeTracking')
      },
    {
      path: '/home/toryinformation',
      name: 'toryinformation',
      meta: {
        oneTitle: '库存管理',
        twoTitle: '库存信息'
      },
      component: r => require.ensure([], () => r(require('../components/inventory/information.vue')), 'orderGet')
    },
    {
      path: '/home/overseasinformation',
      name: 'overseasinformation',
      meta: {
        oneTitle: '库存管理',
        twoTitle: '海外库存管理'
      },
      component: r => require.ensure([], () => r(require('../components/inventory/overseasinformation.vue')), 'overseasinformation')
    },
    {
      path: '/home/inventoryNew',
      name: 'inventoryNew',
      meta: {
        oneTitle: '库存管理',
        twoTitle: '库存信息'
      },
      component: r => require.ensure([], () => r(require('../components/inventoryNew.vue')), 'inventoryNew')
    },
    {
      path: '/home/indetalis',
      name: 'indetalis',
      component: r => require.ensure([], () => r(require('../components/inventory/indetalis.vue')), 'orderGet')
    },
    {
      path: '/home/changeinform',
      name: 'changeinform',
      meta: {
        oneTitle: '库存管理',
        twoTitle: '库存变动记录'
      },
      component: r => require.ensure([], () => r(require('../components/inventory/changeinform.vue')), 'orderGet')
    },
    {
      path: '/home/optionalGoods',
      name: 'optionalGoods',
      meta: {
        oneTitle: '商品管理',
        twoTitle: '自选商品库'
      },
      component: r => require.ensure([], () => r(require('../components/product/optionalGoods.vue')), 'orderGet')
    },
    {
      path: '/home/mappingList',
      name: 'mappingList',
      component: r => require.ensure([], () => r(require('../components/product/mappingList.vue')), 'orderGet')
    },
    {
      path: '/home/wholesale',
      name: 'wholesale',
      meta: {
        oneTitle: '工单管理',
        twoTitle: '一件代发'
      },
      component: r => require.ensure([], () => r(require('../components/workOrder/wholesale.vue')), 'orderGet')
    },
    {
      path: '/home/settingHome',
      name: 'settingHome',
      component: r => require.ensure([], () => r(require('../components/setting/settingHome.vue')), 'orderGet')
    },
    {
      path: '/home/orderCollection',
      name: 'orderCollection',
      meta: {
        oneTitle: '工单管理',
        twoTitle: '工单类型'
      },
      component: r => require.ensure([], () => r(require('../components/workOrder/orderCollection.vue')), 'orderGet')
    },
    {
      path: '/home/reviewProduct',
      name: 'reviewProduct',
      meta: {
        oneTitle: '商品管理',
        twoTitle: '审核商品'
      },
      component: r => require.ensure([], () => r(require('../components/product/reviewProduct.vue')), 'orderGet')
    },
    {
      path: '/home/operationRecords',
      name: 'operationRecords',
      meta: {
        oneTitle: '商品管理',
        twoTitle: '操作记录'
      },
      component: r => require.ensure([], () => r(require('../components/product/operationRecords.vue')), 'orderGet')
    },
    {
      path: '/home/recordsDetails',
      name: 'recordsDetails',
      meta: {
        oneTitle: '商品管理 > 操作记录',
        twoTitle: '记录详情'
      },
      component: r => require.ensure([], () => r(require('../components/product/recordsDetails.vue')), 'orderGet')
    },
    {
      path: '/home/LogisticsQuotation',
      name: 'LogisticsQuotation',
      meta: {
        oneTitle: '工具管理',
        twoTitle: '国际物流查询'
      },
      component: r => require.ensure([], () => r(require('../components/workOrder/LogisticsQuotation.vue')), 'orderGet')
    },
    {
      path: '/home/watermark',
      name: 'watermark',
      meta: {
        oneTitle: '工具管理',
        twoTitle: '水印管理'
      },
      component: r => require.ensure([], () => r(require('../components/workOrder/watermark.vue')), 'orderGet')
    },
    {
      path: '/home/platformShops',
      name: 'platformShops',
      meta: {
        twoTitle: '平台店铺'
      },
      component: r => require.ensure([], () => r(require('../components/workOrder/platformShops.vue')), 'platformShops')
    },
    ]
  },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js